export const comments_5618852 = {"data":{"data":[],"links":{}}}